import React from 'react';
const BaseContext = React.createContext();
export default BaseContext;